export const REQUIRED_CONSENTS_MISSING_EVENT_NAME = 'zoofizjo:required-consents-missing';
